import { Instance, types } from "mobx-state-tree";

export const ChatNotification = types
  .model("ChatNotification", {
    message: types.string,
    type: types.number,
    level: types.number,
    actionText: types.maybe(types.string),
    isDismissDisabled: types.maybe(types.boolean)
  })
  .extend(() => {
    const callbacks: { onAction?: () => void; onCancel?: () => void } = {};

    const actions = {
      setOnAction(callback: () => void) {
        callbacks.onAction = callback;
      },
      setOnCancel(callback: () => void) {
        callbacks.onCancel = callback;
      }
    };

    const views = {
      get onAction() {
        return callbacks.onAction;
      },
      get onCancel() {
        return callbacks.onCancel;
      }
    };

    return { views, actions };
  });

export interface IChatNotification extends Instance<typeof ChatNotification> {}
